const btn = document.querySelector('.collection-header__see-more');
const desc = document.querySelector('.collection-header__description');
const seeMore = btn.getAttribute('data-show-more');
const seeLess = btn.getAttribute('data-show-less');
console.log(seeMore);
console.log(seeLess);
btn.addEventListener('click', () => {
  if (desc.classList.contains('description-see-more')) {
    desc.classList.remove('description-see-more');
    btn.querySelector('span').innerHTML = seeLess;
  } else {
    desc.classList.add('description-see-more');
    btn.querySelector('span').innerHTML = seeMore;
  }
});